import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const { lang } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const language = lang === 'ar' ? 'ar' : 'en';
  const direction = language === 'ar' ? 'rtl' : 'ltr';

  useEffect(() => {
    document.documentElement.dir = direction;
    document.documentElement.lang = language;
  }, [language, direction]);

  const toggleLanguage = () => {
    const newLang = language === 'en' ? 'ar' : 'en';
    const pathAfterLang = location.pathname.replace(/^\/(en|ar)/, '');
    navigate(`/${newLang}${pathAfterLang}`);
  };

  const value = useMemo(() => ({ language, direction, toggleLanguage }), [language, direction, location.pathname]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

export default LanguageContext; 